import { CacheProvider } from '@emotion/react';
import { CssBaseline, useTheme } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import dynamic from 'next/dynamic';
import React from 'react';

import ConfigureJSS from 'components/common/RTL.jsx';
import { themeOptions } from 'theme/default';

import LocaleProvider from './LocaleProvider';

const NextNProgress = dynamic(() => import('nextjs-progressbar'));
const CustomBackdrop = dynamic(() => import('components/common/Backdrop'), { suspense: true });
const CustomSnackbar = dynamic(() => import('components/common/Snackbar'), { suspense: true });

const KeepaThemeProvider = ({ children, emotionCache }) => {
	const muiTheme = useTheme();

	React.useEffect(() => {
		const jssStyles = document.querySelector('#jss-server-side');
		if (jssStyles) {
			jssStyles.parentElement.removeChild(jssStyles);
		}
	});

	const theme = createTheme({
		...muiTheme,
		...themeOptions,
		direction: 'rtl',
	});

	return (
		<CacheProvider value={emotionCache}>
			<ConfigureJSS>
				<ThemeProvider theme={theme}>
					<NextNProgress color={'#FFA500'} />
					<LocaleProvider>
						<CssBaseline />
						{children}
					</LocaleProvider>
					<CustomSnackbar />
					<CustomBackdrop />
				</ThemeProvider>
			</ConfigureJSS>
		</CacheProvider>
	);
};

export default KeepaThemeProvider;
